<template>
  <div class="modal_copy_settings">
    <div class="modal_copy_settings__header">
      <h4 class="title">
<!--        {{ translate("project.new") }}-->
        {{ translate('invoice.copy_settings.copy_invoice_details') }}
      </h4>
    </div>

    <div class="modal_copy_settings__body">
      <div class="settings_block">
        <div class="line">
          <div class="filter slider-switch checkbox">
            <div class="info">
              {{ translate('invoice.copy_settings.sort_by_fid') }}
            </div>
            <label class="switch" @click.prevent="settings.sort_by_fid = !settings.sort_by_fid">
              <input type="checkbox" v-model="settings.sort_by_fid" />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="filter slider-switch checkbox">
            <div class="info">
              {{ translate('invoice.copy_settings.replace_dot') }}
            </div>
            <label class="switch" @click.prevent="settings.replace_dot = !settings.replace_dot">
              <input type="checkbox" v-model="settings.replace_dot" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="line">
          <div class="filter slider-switch checkbox">
            <div class="info">
              {{ translate('invoice.copy_settings.skip_zero') }}
            </div>
            <label class="switch" @click.prevent="settings.skip_zero = !settings.skip_zero">
              <input type="checkbox" v-model="settings.skip_zero" />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="filter slider-switch checkbox">
            <div class="info">
              {{ translate('invoice.copy_settings.add_days') }}
            </div>
            <label class="switch" @click.prevent="settings.add_days = !settings.add_days">
              <input type="checkbox" v-model="settings.add_days" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="line">
          <div class="filter slider-switch checkbox">
            <div class="info">
              {{ translate('invoice.copy_settings.use_order') }}
            </div>
            <label class="switch" @click.prevent="settings.use_order = !settings.use_order">
              <input type="checkbox" v-model="settings.use_order" />
              <span class="slider round"></span>
            </label>
          </div>

          <div class="filter slider-switch checkbox">
            <div class="info">
              {{ translate('invoice.copy_settings.date_transform') }}
            </div>
            <label class="switch" @click.prevent="settings.date_transform = !settings.date_transform">
              <input type="checkbox" v-model="settings.date_transform" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="line">
<!--          <div class="filter slider-switch checkbox">-->
<!--            <div class="info">-->
<!--              {{ translate('invoice.copy_settings.without_vat') }}-->
<!--            </div>-->
<!--            <label class="switch" @click.prevent="settings.without_vat = !settings.without_vat">-->
<!--              <input type="checkbox" v-model="settings.without_vat" />-->
<!--              <span class="slider round"></span>-->
<!--            </label>-->
<!--          </div>-->

        </div>
      </div>
    </div>
    <div class="modal_copy_settings__footer">
      <span
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="copy"
      >
        {{ translate('invoice.copy_info_in_buffer') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

export default {
  name: 'CopySettingsModal',
  components: { },
  data () {
    return {
      settings: {
        sort_by_fid: true,
        replace_dot: true,
        skip_zero: true,
        add_days: false,
        without_vat: false,
        date_transform: false,
        use_order: false
      },
    }
  },
  methods: {
    copy(){
      this.$emit('copy', this.settings)
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_copy_settings{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      .settings_block{
        width: 100%;
        height: 100%;
        .line{
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
          .filter{
            margin: 10px 0;
            width: 50%;
          }
        }
      }
    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
